import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
            关于我们
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10">
            {aboutData.title}
          </p>

          <div className="space-y-4 mb-10">
            {aboutData.paragraphs.map((p, idx) => (
              <p key={idx} className="text-sm text-foreground-600 leading-relaxed">
                {p}
              </p>
            ))}
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {aboutData.stats.map((stat, idx) => (
              <div
                key={idx}
                className="text-center p-5 rounded-xl bg-background-50 border border-background-200/70"
              >
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600 mb-1">
                  {stat.value}
                </div>
                <div className="text-xs text-foreground-400">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}